import React, { useEffect, useMemo, useState } from 'react'

import { useIsIntlRestaurant } from 'src/lib/js/hooks/useIsIntlRestaurant'

import AnimatedSection from 'public/components/default_template/online_ordering/checkout/AnimatedSection'
import OrderSection from 'public/components/default_template/online_ordering/checkout/OrderSection'
import PaymentSection from 'public/components/default_template/online_ordering/checkout/payment/PaymentSection'
import { useCart } from 'public/components/online_ordering/CartContext'
import { useCheckout } from 'public/components/online_ordering/CheckoutContext'
import {
  PaymentOption,
  usePayment
} from 'public/components/online_ordering/PaymentContext'

import CheckoutNote, { UberCheckoutNote } from './CheckoutNote'
import SubmitOrderButton from './SubmitOrderButton'
import ContinuePaymentButton from './international/ContinuePaymentButton'
import InternationalPaymentContainer from './international/InternationalPaymentContainer'
import CheckoutFulfillmentSection from 'public/components/default_template/online_ordering/checkout/CheckoutFulfillmentSection'
import TipCheckoutSection from 'src/public/components/default_template/online_ordering/checkout/payment/TipCheckoutSection'
import { DiningOptionBehavior } from 'src/apollo/onlineOrdering'
import ReviewOrderModal from './ReviewOrderModal'
import CheckoutAuth from './CheckoutAuth'

const CheckoutSections = () => {
  const { cart } = useCart()
  const { orderTotal, orderError, reviewModalOpen, setReviewModalOpen } =
    useCheckout()
  const { paymentOption } = usePayment()
  const isIntlRestaurant = useIsIntlRestaurant()
  const [showIntlPayment, setShowIntlPayment] = useState<boolean>(false)
  const canPayAtCheckout = !(
    cart?.paymentOptions.atCheckout.length === 0 &&
    cart?.paymentOptions.uponReceipt.length > 0
  )

  useEffect(() => {
    if (isIntlRestaurant && orderError) {
      setShowIntlPayment(false)
    }
  }, [isIntlRestaurant, orderError])

  const isDeliveryOrder: boolean = useMemo(() => {
    return cart?.diningOptionBehavior === DiningOptionBehavior.Delivery
  }, [cart])

  return (
    <>
      <CheckoutAuth />
      <CheckoutFulfillmentSection />
      <OrderSection />
      {isDeliveryOrder && <TipCheckoutSection />}
      <AnimatedSection
        expanded={!showIntlPayment}
        slowTransition
        testid='animated-payment-section'
      >
        <div className='checkoutFormContents' data-testid='checkoutFormInfo'>
          <PaymentSection isExpanded={!showIntlPayment} />
          <div className='sectionButton'>
            {isIntlRestaurant &&
            orderTotal > 0 &&
            canPayAtCheckout &&
            paymentOption === PaymentOption.PayNow ? (
              <ContinuePaymentButton
                enableIntlPayment={() => setShowIntlPayment(true)}
              />
            ) : (
              <SubmitOrderButton />
            )}
            <CheckoutNote
              showIntlPayment={showIntlPayment}
              paymentOption={paymentOption}
            />
          </div>
        </div>
      </AnimatedSection>
      {isIntlRestaurant && (
        <InternationalPaymentContainer
          expanded={showIntlPayment}
          hideIntlPayment={() => setShowIntlPayment(false)}
        />
      )}
      <UberCheckoutNote />
      {!isIntlRestaurant && (
        <ReviewOrderModal
          isOpen={reviewModalOpen}
          onClose={() => setReviewModalOpen(false)}
        />
      )}
    </>
  )
}

export default CheckoutSections
